import { useParams } from "react-router-dom";

import { useCase } from "../api/useCase";
import { MobileCaseDetailView } from "./MobileCaseDetailView";

export function MobileCaseDetailContainer() {
  const { caseId } = useParams<{ caseId: string }>();
  const { data: caseItem, isLoading, isError } = useCase(caseId);

  return (
    <MobileCaseDetailView caseId={caseId} case={caseItem} isLoading={isLoading} isError={isError} />
  );
}
